import { render, staticRenderFns } from "./SiteCopyright.vue?vue&type=template&id=73983ea2"
import script from "./SiteCopyright.vue?vue&type=script&lang=js"
export * from "./SiteCopyright.vue?vue&type=script&lang=js"
import style0 from "./SiteCopyright.vue?vue&type=style&index=0&id=73983ea2&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports